export function owed(rate: number, cap: number | null, flat: number, miles: number): number {
  let perMile = rate * miles;
  if (cap != null) perMile = Math.min(perMile, cap);
  return perMile + (flat || 0);
}

export function projected(rate: number, cap: number | null, flat: number, goal: number): number {
  return owed(rate, cap, flat, goal);
}

export function money(n: number): string {
  return "$" + Math.round(n).toLocaleString();
}

export function money2(n: number): string {
  return "$" + n.toFixed(2);
}
